import api from './api';

const presupuestoService = {
  listar: async (anio, mes) => {
    const { data } = await api.get('/presupuestos', { params: { anio, mes } });
    return data.data;
  },

  crear: async (presupuesto) => {
    const { data } = await api.post('/presupuestos', presupuesto);
    return data.data;
  },

  actualizar: async (id, presupuesto) => {
    const { data } = await api.put(`/presupuestos/${id}`, presupuesto);
    return data.data;
  },

  eliminar: async (id) => {
    await api.delete(`/presupuestos/${id}`);
  },
};

export default presupuestoService;